export default {
      id: "icc-logo-color-usage",
      viewBox: "0 0 87.98 143.46",
      url: __webpack_public_path__ + "img/icons.8ad0c046.svg#icc-logo-color",
      toString: function () {
        return this.url;
      }
    }